import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "EventCollectionstyles__Container",
  componentId: "keen-query-creator__sc-1lilg7j-0"
})(["&&&{position:relative;}"]);